/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */

/**
 * * `TOP` - Top
 * * `BOTTOM` - Bottom
 * * `FOOTWEAR` - Footwear
 * * `OTHER` - Other
 */
export type SectionEnum = typeof SectionEnum[keyof typeof SectionEnum];


export const SectionEnum = {
  TOP: 'TOP',
  BOTTOM: 'BOTTOM',
  FOOTWEAR: 'FOOTWEAR',
  OTHER: 'OTHER',
} as const;
